export type ApplicationStage = 
  | 'new'
  | 'first_contact'
  | 'phone_interview'
  | 'onsite_interview'
  | 'trial_work'
  | 'offer'
  | 'hired'
  | 'rejected';

export interface SpecialCertification {
  type: string;
  name: string;
  valid_until?: string;
  notes?: string;
}

export interface Applicant {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  address_street?: string;
  address_zip?: string;
  address_city?: string;
  address_country?: string;
  birth_date?: string;
  desired_position?: string;
  salary_expectation?: number;
  earliest_start_date?: string;
  drivers_license?: string;
  drivers_license_classes?: any;
  qualifications?: string;
  cv_url?: string;
  certificates_urls?: string[];
  current_stage: ApplicationStage;
  notes?: string;
  rating?: number;
  interview_notes?: string;
  references_info?: string;
  rejection_reason?: string;
  source?: string;
  created_at: string;
  updated_at: string;
  created_by?: string;
  converted_to_employee_id?: string;
  special_certifications?: any;
  security_clearance_valid_until?: string;
  career_summary?: string;
}

export interface ApplicantStageHistory {
  id: string;
  applicant_id: string;
  from_stage?: ApplicationStage;
  to_stage: ApplicationStage;
  changed_by?: string;
  notes?: string;
  created_at: string;
}

export interface LandingPageConfig {
  id: string;
  title: string;
  subtitle?: string;
  description?: string;
  background_color: string;
  text_color: string;
  accent_color: string;
  logo_url?: string;
  background_image_url?: string;
  show_company_info: boolean;
  custom_css?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export const stageLabels: Record<ApplicationStage, string> = {
  new: 'Neu',
  first_contact: 'Erstkontakt',
  phone_interview: 'Telefoninterview',
  onsite_interview: 'Vor-Ort-Gespräch',
  trial_work: 'Probearbeiten',
  offer: 'Angebot',
  hired: 'Eingestellt',
  rejected: 'Abgelehnt'
};

export const stageColors: Record<ApplicationStage, string> = {
  new: 'bg-blue-500',
  first_contact: 'bg-cyan-500',
  phone_interview: 'bg-indigo-500',
  onsite_interview: 'bg-purple-500',
  trial_work: 'bg-amber-500',
  offer: 'bg-emerald-500',
  hired: 'bg-green-600',
  rejected: 'bg-red-500'
};

export const stageOrder: ApplicationStage[] = [
  'new',
  'first_contact',
  'phone_interview',
  'onsite_interview',
  'trial_work',
  'offer',
  'hired',
  'rejected'
];
